import * as React from "react"
import { Eye, EyeOff, Landmark, Plus } from "lucide-react"
import { formatMonthYear } from "@/shared/utils"
import { Button } from "@/shared/ui/atoms/Button"

interface CarteraHeroProps {
  amountsVisible: boolean
  periodLabel?: string
  onToggleAmounts: () => void
  onOpenAccountDialog: () => void
  onOpenTransactionDialog: () => void
}

export const CarteraHero = React.memo(function CarteraHero({
  amountsVisible,
  periodLabel,
  onToggleAmounts,
  onOpenAccountDialog,
  onOpenTransactionDialog,
}: CarteraHeroProps) {
  const currentMonth = periodLabel || formatMonthYear()

  return (
    <header className="cartera-hero flex flex-col gap-4 sm:gap-5">
      <div className="flex flex-col justify-between gap-4 lg:flex-row lg:items-end">
        <div className="flex flex-col gap-1.5 sm:gap-2">
          <p className="cartera-eyebrow">Tu sistema financiero</p>
          <div className="flex flex-wrap items-baseline gap-x-3 gap-y-1">
            <h1 className="cartera-title">Cartera</h1>
            <span className="text-xs sm:text-sm text-muted-foreground capitalize font-medium">
              {currentMonth}
            </span>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-2 sm:gap-2.5">
          <Button
            variant="outline"
            size="sm"
            onClick={onToggleAmounts}
            className="h-9 text-xs sm:text-sm flex-1 sm:flex-initial justify-center"
          >
            {amountsVisible ? (
              <EyeOff data-icon="inline-start" className="size-3.5 sm:size-4" />
            ) : (
              <Eye data-icon="inline-start" className="size-3.5 sm:size-4" />
            )}
            <span>{amountsVisible ? "Ocultar cifras" : "Mostrar cifras"}</span>
          </Button>

          <Button
            variant="outline"
            size="sm"
            onClick={onOpenAccountDialog}
            className="h-9 text-xs sm:text-sm flex-1 sm:flex-initial justify-center"
          >
            <Landmark data-icon="inline-start" className="size-3.5 sm:size-4" />
            <span>Nueva cuenta</span>
          </Button>

          <Button
            size="sm"
            onClick={onOpenTransactionDialog}
            className="h-9 text-xs sm:text-sm w-full sm:w-auto justify-center shadow-xs"
          >
            <Plus data-icon="inline-start" className="size-3.5 sm:size-4" />
            <span>Nuevo registro</span>
          </Button>
        </div>
      </div>
    </header>
  )
})

